<div class="p-fluid">
  <span>
    <div *ngIf="props.label" class="b-f-slider-label">
      <label
        *ngIf="props.label"
        [attr.for]="id"
        class="slider-label"
        [for]="field.id"
        >{{ props.label
        }}<span *ngIf="props.required">
          {{ props.required ? '*' : '' }}
        </span>
      </label>
      <div
        *ngIf="props.tooltip"
        class="symbol-info b-f-slider-tooltip tooltip-icon"
        [pTooltip]="props.tooltip"
      ></div>
    </div>
    <p-slider
      #slider
      [min]="props.min ? props.min : 0"
      [max]="props.max ? props.max : 100"
      [orientation]="props.orientation ? props.orientation : 'horizontal'"
      [step]="props.step && props.step"
      [range]="props.range && props.range"
      [formControl]="formControl"
      [formlyAttributes]="field"
    >
    </p-slider>
  </span>
  <div
    *ngIf="props && props.description"
    class="b-f-slider-descriptioncontainer"
  >
    <small
      [ngClass]="{
        'basin-action-link p-button-text b-f-slider-actiondescription':
          props.actionDescription,
        'b-f-slider-description': true
      }"
      (click)="props.actionDescription && actionDescriptionClicked($event)"
      >{{ props.description }}</small
    >
  </div>
</div>
